import { render, staticRenderFns } from "./baseDialog.vue?vue&type=template&id=70ca761f"
import script from "./baseDialog.vue?vue&type=script&lang=js"
export * from "./baseDialog.vue?vue&type=script&lang=js"
import style0 from "./baseDialog.vue?vue&type=style&index=0&id=70ca761f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports